import React from "react";
import "./AddModalInputField.css";

export default function AddModalInputField({
  icon,
  placeholder,
  value,
  onChange,
  type,
  style,
  disabled = false,
}) {
  return (
    <div className="add-modal-content">
      {icon}
      <input
        style={style}
        type={type}
        className="add-modal-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
}
